import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSuff',
})
export class ThousandSuffixesPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    let inputData = input,
      sign = '';

    if (input < 0) {
      inputData = Math.abs(input);
      sign = '-';
    }
    var exp,
      rounded,
      suffixes = ['k', 'M', 'G', 'T', 'P', 'E'];
    if (Number.isNaN(input)) {
      return null;
    }

    if (inputData < 1000) {
      return input;
    }

    exp = Math.floor(Math.log(inputData) / Math.log(1000));
    return (
      sign + (inputData / Math.pow(1000, exp)).toFixed(args) + suffixes[exp - 1]
    );
  }
}
